import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@bonusly/design-system';

interface Props {
	isOpen: boolean;
	onConfirm: VoidFunction;
	onClose: VoidFunction;
}

export const GiveModalConfirmDelete: FC<Props> = ({ isOpen, onClose, onConfirm }) => {
	const { t } = useTranslation('video');

	return (
		<Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="sm">
			<ModalOverlay onClick={onClose} />
			<ModalContent>
				<ModalHeader border="none">{t('delete_modal.heading')}</ModalHeader>
				<ModalCloseButton borderRadius="full" top={4} />
				<ModalBody>
					<Text>{t('delete_modal.body')}</Text>
				</ModalBody>

				<ModalFooter px={5} pb={5}>
					<Button data-testid="delete-cancel" colorScheme="primary" mr={4} variant="link" onClick={onClose}>
						{t('delete_modal.actions.cancel')}
					</Button>
					<Button data-testid="delete-confirm" colorScheme="primary" variant="solid" onClick={onConfirm}>
						{t('delete_modal.actions.delete')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
